import DownloadController from './controllers/download-controller';
import downloadTemplateUrl from './views/download.tpl.html';
import indexTemplateUrl from './views/index.tpl.html';
import MediaIndexController from './controllers/index-controller';

angular
    .module('festzelt-os.modules.media')
    .config([
        '$stateProvider',
        config
    ]);

function config($stateProvider) {
    $stateProvider
        .state('app.media', {
            abstract: true,
            url: '/media',
            template: '<ui-view/>'
        })
        .state('app.media.downloads', {
            url: '/download/{fileUuid}',
            controller: DownloadController,
            controllerAs: 'vm',
            templateUrl: downloadTemplateUrl
        })
        .state('app.media.index', {
            url: '',
            controller: MediaIndexController,
            controllerAs: 'vm',
            templateUrl: indexTemplateUrl
        })
}



// WEBPACK FOOTER //
// ./src/app/modules/media/routes.js